import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    paddingLeft: 25,
    paddingRight: 25,
    gap: 20,
  },
  card: {
    backgroundColor: "#fff",
    marginTop: 20,
    marginBottom: 30,
    marginLeft: "10%",
    shadowColor: "#000",
    width: 250, // 328px / 2
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  frontCover: {
    marginBottom: 12,
    width: "100%",
    height: 140,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
  },
  nameCategory: {
    position: "absolute",
    marginTop: 110,
    textAlign: "center",
    color: "#fff",
    fontWeight: "bold",
    width: "100%",
  },
  nameCategoryOnDescription: {
    color: "#000000",
    textTransform: "uppercase",
    marginBottom: 8,
    fontSize: 16,
  },
  contentDescription: {
    padding: 10,
    paddingTop: 0,
    marginTop: 10,
    height: 230,
  },
  textDescription: {
    fontSize: 14,
    color: "#000000",
    textAlign: "justify",
  },
  contentBtn: {
    position: "absolute",
    bottom: 6,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  button: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 4,
    width: 240,
    height: 40,
    backgroundColor: "#077A97",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 14,
    fontWeight: "500",
  },
});

export default styles;
